import React, { useState } from "react";
import { SelectList } from "components/table/DataTable/Fields";
import strings from "localisation/strings";
import MapInterface from "api/models/MapInterface";
import { MapCurationPayload } from "api/models/Plan";
import { SelectItem } from "components/forms/Select";

interface MapsDropdownSingleSelectProps {
  allMaps: MapInterface[];
  value: MapCurationPayload;
  entityId?: string;
  fieldName: string;
  width?: string;
  style?: string;
  getMapById: (mapId: any) => MapInterface | undefined;
  onChange: (selectedField: any, selectedValue: any) => void;
}

interface StringSelectOption {
  value: string;
  label: string;
}

const mapToSelectOption = (map: MapInterface): StringSelectOption => ({
  value: map.id,
  label: map.mapName,
});

const MapsDropdownSingleSelect = ({
  allMaps,
  value,
  fieldName,
  width,
  style,
  onChange,
  getMapById,
}: MapsDropdownSingleSelectProps) => {
  const map = getMapById(value);
  const [selectedMap, setSelectedMap] = useState<SelectItem | undefined>(
    map ? mapToSelectOption(map) : undefined,
  );

  const mapsForSelectList: StringSelectOption[] = allMaps
    .map(mapToSelectOption)
    .sort((a, b) => a.label.localeCompare(b.label));

  const onItemSelect = (selectedItem: SelectItem) => {
    setSelectedMap(selectedItem);
    onChange(fieldName, selectedItem?.value);
  };

  return (
    <SelectList
      options={mapsForSelectList}
      onChange={onItemSelect}
      placeholder={strings(
        "businessSettings.additional-settings.fields.mapSelection.placeholder",
      )}
      width={width || "50%"}
      classNamePrefix="mapDropdown"
      value={selectedMap}
      style={style}
    />
  );
};

export default MapsDropdownSingleSelect;
